var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03333 3.6C5.53627 3.6 5.13333 4.00294 5.13333 4.5C5.13333 4.99706 5.53627 5.4 6.03333 5.4V3.6ZM6.03333 5.4H16.1667V3.6H6.03333V5.4ZM20.6 9.83333V10.9H22.4V9.83333H20.6ZM16.1667 15.3333H6.03333V17.1333H16.1667V15.3333ZM20.6 10.9C20.6 13.3485 18.6151 15.3333 16.1667 15.3333V17.1333C19.6092 17.1333 22.4 14.3426 22.4 10.9H20.6ZM16.1667 5.4C18.6151 5.4 20.6 7.38487 20.6 9.83333H22.4C22.4 6.39076 19.6092 3.6 16.1667 3.6V5.4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 16.2333L9.7 12.5383L9.7 19.9284L2.5 16.2333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBack);
export default __webpack_public_path__ + "static/media/ic_back.dc6eed0606cfc881714faf2baa191a5f.svg";
export { ForwardRef as ReactComponent };